import React from 'react';
import ReactDOM from 'react-dom';
import CScontactForm from './page/components/CScontactForm';
import '../../styles/templates/pages/page.cs-contact-form.scss';

ReactDOM.render(<CScontactForm />, document.getElementById('CsContactForm'));
